(() => {
  const root = document.documentElement;

  if (!root.classList.contains("shopify-site-intro-active")) {
    return;
  }

  const startedAt =
    window.__SHOPIFY_SITE_INTRO_STARTED_AT__ ?? performance.now();

  const waitForWindowLoad = () => {
    if (document.readyState === "complete") {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      window.addEventListener("load", resolve, { once: true });
    });
  };

  const waitForImage = (image) => {
    if (!image) {
      return Promise.resolve();
    }

    if (image.complete) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      image.addEventListener("load", resolve, { once: true });
      image.addEventListener("error", resolve, { once: true });
    });
  };

  const start = () => {
    const intro = document.getElementById("ShopifySiteIntro");

    if (!intro) {
      root.classList.remove(
        "shopify-site-intro-active",
        "shopify-site-intro-playing"
      );
      return;
    }

    const logo = intro.querySelector(".shopify-site-intro__logo");
    const holdMs = Number.parseFloat(intro.dataset.holdMs) || 0;
    const durationMs = Number.parseFloat(intro.dataset.durationMs) || 0;

    const elapsed = performance.now() - startedAt;
    const remainingHold = Math.max(0, holdMs - elapsed);

    const waitForHold = new Promise((resolve) => {
      window.setTimeout(resolve, remainingHold);
    });

    Promise.all([
      waitForHold,
      waitForWindowLoad(),
      waitForImage(logo),
    ]).then(() => {
      root.classList.add("shopify-site-intro-playing");

      let finished = false;

      const finish = () => {
        if (finished) {
          return;
        }

        finished = true;

        root.classList.remove(
          "shopify-site-intro-active",
          "shopify-site-intro-playing"
        );

        intro.remove();
      };

      if (logo) {
        logo.addEventListener("animationend", finish, { once: true });
      }

      // Fallback in case animation end doesn't run for some reason
      window.setTimeout(finish, durationMs + 100);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
